// composables/useLocales.ts

// Cache global de mensagens i18n (simples, sem useState)
const i18nMessagesCache: Record<string, any> = {};

export const useLocales = () => {
  const { data, error, pending, refresh } = useFetch("/api/locales", {
    server: false,
  });

  return { data, error, pending, refresh };
};

/**
 * Fetch mensagens i18n com cache
 * Se já foram carregadas antes, retorna do cache
 * Caso contrário, faz fetch e guarda em cache
 */
export const fetchI18nMessages = async (locale: string) => {
  // Se já está em cache, retorna logo
  if (i18nMessagesCache[locale]) {
    console.log(`[fetchI18nMessages] ${locale} em cache, retornando`);
    return i18nMessagesCache[locale];
  }

  console.log(`[fetchI18nMessages] Fetching ${locale} de /api/i18n/${locale}`);
  try {
    const messages = await $fetch(`/api/i18n/${locale}`);
    console.log(
      `[fetchI18nMessages] ${locale} resposta recebida:`,
      Object.keys(messages || {}).length,
      "chaves"
    );

    if (messages && typeof messages === "object") {
      i18nMessagesCache[locale] = messages;
      return messages;
    }
  } catch (err) {
    console.error(`[fetchI18nMessages] Erro ao carregar ${locale}:`, err);
  }

  console.warn(`[fetchI18nMessages] ${locale} retornou vazio`);
  return {};
};
